function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { showToast } from 'vant';
import 'vant/es/toast/style';
import 'vant/es/pull-refresh/style';
import 'vant/es/list/style';
import 'vant/es/empty/style';
import 'vant/es/button/style';
import 'vant/es/icon/style';
import '../../qipao_bridge';
import { UserApi, PostsApi } from '../../api';
import wechatJsSdkMixin from '../../mixins/wechatJsSdkMixin';
import userHomeInAppOpen from '../../mixins/userHomeInAppOpen';
import WechatOpenLaunchApp from '../../components/global/WechatOpenLaunchApp.vue';
var DEFAULT_BE_USER_ID = 'a0217bfc-c5d8-405e-bb64-b9a8bc00990b';
export default {
  name: 'OtherUserHome',
  components: {
    WechatOpenLaunchApp: WechatOpenLaunchApp
  },
  mixins: [wechatJsSdkMixin, userHomeInAppOpen],
  data: function data() {
    return {
      beUserId: DEFAULT_BE_USER_ID,
      refreshing: false,
      loading: false,
      finished: false,
      error: false,
      page: 1,
      size: 10,
      items: [],
      user: null
    };
  },
  computed: {
    userName: function userName() {
      var _this$user, _this$user2, _this$user3;
      return ((_this$user = this.user) === null || _this$user === void 0 ? void 0 : _this$user.user_name) || ((_this$user2 = this.user) === null || _this$user2 === void 0 ? void 0 : _this$user2.userName) || ((_this$user3 = this.user) === null || _this$user3 === void 0 ? void 0 : _this$user3.nickname) || '用户';
    },
    userBio: function userBio() {
      var _this$user4, _this$user5, _this$user6;
      var v = ((_this$user4 = this.user) === null || _this$user4 === void 0 ? void 0 : _this$user4.user_bio) || ((_this$user5 = this.user) === null || _this$user5 === void 0 ? void 0 : _this$user5.bio) || ((_this$user6 = this.user) === null || _this$user6 === void 0 ? void 0 : _this$user6.signature) || '';
      return String(v || '');
    },
    avatarUrl: function avatarUrl() {
      var _this$user7, _this$user8, _this$user9;
      return this.sanitizeUrl(((_this$user7 = this.user) === null || _this$user7 === void 0 ? void 0 : _this$user7.user_head_url) || ((_this$user8 = this.user) === null || _this$user8 === void 0 ? void 0 : _this$user8.avatar) || ((_this$user9 = this.user) === null || _this$user9 === void 0 ? void 0 : _this$user9.avatar_url) || '');
    },
    bgUrl: function bgUrl() {
      var _this$user0, _this$user1, _this$user10;
      return this.sanitizeUrl(((_this$user0 = this.user) === null || _this$user0 === void 0 ? void 0 : _this$user0.user_back_url) || ((_this$user1 = this.user) === null || _this$user1 === void 0 ? void 0 : _this$user1.background) || ((_this$user10 = this.user) === null || _this$user10 === void 0 ? void 0 : _this$user10.background_url) || '');
    },
    headerBgStyle: function headerBgStyle() {
      if (!this.bgUrl) return {};
      return {
        backgroundImage: "url('".concat(this.bgUrl, "')"),
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundSize: 'cover'
      };
    },
    ipText: function ipText() {
      var _this$user11, _this$user12;
      var ip = ((_this$user11 = this.user) === null || _this$user11 === void 0 ? void 0 : _this$user11.ip_address) || ((_this$user12 = this.user) === null || _this$user12 === void 0 ? void 0 : _this$user12.ip) || '';
      return ip ? "IP\u5C5E\u5730\uFF1A".concat(ip) : '';
    },
    followerCount: function followerCount() {
      return this.getCountValue(['followed_be_user_count', 'fans_count', 'follower_count', 'followers', 'fans']);
    },
    followCount: function followCount() {
      return this.getCountValue(['followed_user_count', 'follow_count', 'following_count', 'following']);
    },
    likedCount: function likedCount() {
      return this.getCountValue(['like_count', 'liked_count', 'likes_count', 'likes']);
    },
    /**
     * 是否展示空态/错误态占位（隐藏 van-list）
     * - 列表为空、未在加载、未下拉刷新中
     * - 已加载完毕或刚发生过错误时才弹出，避免初次进入闪烁
     * @returns {boolean}
     */
    showEmpty: function showEmpty() {
      return !this.loading && !this.refreshing && this.items.length === 0 && (this.finished || this.error);
    },
    /**
     * van-list 完成态文案：列表为空时隐藏，避免与空态重复
     * @returns {string}
     */
    finishedText: function finishedText() {
      return this.items.length > 0 ? '没有更多了' : '';
    }
  },
  methods: {
    sanitizeUrl: function sanitizeUrl(value) {
      return String(value || '').replace(/`/g, '').trim().replace(/^['"]+|['"]+$/g, '');
    },
    getCoverUrl: function getCoverUrl(item) {
      return this.sanitizeUrl((item === null || item === void 0 ? void 0 : item.cover_url) || (item === null || item === void 0 ? void 0 : item.coverUrl) || '');
    },
    getBridge: function getBridge() {
      if (typeof window === 'undefined') return null;
      return window.QipaoBridge || null;
    },
    getCountValue: function getCountValue(keys) {
      var base = this.user || {};
      for (var i = 0; i < keys.length; i++) {
        var v = base[keys[i]];
        if (v !== undefined && v !== null && v !== '') return v;
      }
      return 0;
    },
    resolveBeUserId: function resolveBeUserId() {
      var _this$$route, _this$$route$params, _this$$route2, _this$$route2$query, _this$$route3, _this$$route3$query;
      var fromParams = (_this$$route = this.$route) === null || _this$$route === void 0 ? void 0 : (_this$$route$params = _this$$route.params) === null || _this$$route$params === void 0 ? void 0 : _this$$route$params.beUserId;
      var fromQuery = ((_this$$route2 = this.$route) === null || _this$$route2 === void 0 ? void 0 : (_this$$route2$query = _this$$route2.query) === null || _this$$route2$query === void 0 ? void 0 : _this$$route2$query.be_user_id) || ((_this$$route3 = this.$route) === null || _this$$route3 === void 0 ? void 0 : (_this$$route3$query = _this$$route3.query) === null || _this$$route3$query === void 0 ? void 0 : _this$$route3$query.beUserId);
      var id = fromParams || fromQuery || DEFAULT_BE_USER_ID;
      this.beUserId = String(id);
    },
    /**
     * 拉取他人主页用户信息，并将 `user_data` 与 `user_info` 合并到 `this.user`，
     * 以便统计字段（如 `followed_be_user_count`）与资料字段同源读取。
     * @returns {Promise<void>}
     */
    fetchUser: function fetchUser() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _res$data, _res$data2, _res$data3, res, userInfo, userData, fallback, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              _context.n = 1;
              return UserApi.userInfoAll({
                isMe: false,
                beUserId: _this.beUserId
              });
            case 1:
              res = _context.v;
              userInfo = (res === null || res === void 0 ? void 0 : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.user_info) || (res === null || res === void 0 ? void 0 : (_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : _res$data2.user) || null;
              userData = res !== null && res !== void 0 && (_res$data3 = res.data) !== null && _res$data3 !== void 0 && _res$data3.user_data && _typeof(res.data.user_data) === 'object' ? res.data.user_data : {};
              fallback = !userInfo ? (res === null || res === void 0 ? void 0 : res.data) || (res === null || res === void 0 ? void 0 : res.user) || null : null;
              _this.user = userInfo || fallback ? _objectSpread(_objectSpread({}, userData || {}), userInfo || fallback || {}) : null;
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              showToast((_t === null || _t === void 0 ? void 0 : _t.message) || '加载用户信息失败');
            case 3:
              return _context.a(2);
          }
        }, _callee, null, [[0, 2]]);
      }))();
    },
    /**
     * 分页加载作品列表
     * - `reset=true`：从第 1 页起重新加载（下拉刷新、初次进入、重试时使用）
     * - 命中尾页：依据返回数量或 `total_count` 标记 `finished`
     * - 异常：标记 `error`，由 van-list 的错误重试或外层「点击重试」按钮触发恢复
     * @param {{ reset?: boolean }} [options]
     * @returns {Promise<void>}
     */
    fetchList: function fetchList() {
      var _arguments = arguments,
        _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _ref, reset, myToken, _res$data4, _res$data5, _res$data6, _res$data7, res, list, items, totalCount, _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _ref = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : {}, reset = _ref.reset;
              if (!_this2._fetching) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2);
            case 1:
              if (!(!reset && _this2.finished)) {
                _context2.n = 2;
                break;
              }
              return _context2.a(2);
            case 2:
              _this2._fetching = true;
              myToken = _this2._fetchToken = (_this2._fetchToken || 0) + 1;
              if (reset) {
                _this2.page = 1;
                _this2.items = [];
                _this2.finished = false;
                _this2.error = false;
              }
              _this2.loading = true;
              _this2.error = false;
              _context2.p = 3;
              _context2.n = 4;
              return PostsApi.newPostUserList({
                page: _this2.page,
                size: _this2.size,
                isMe: false,
                beUserId: _this2.beUserId
              });
            case 4:
              res = _context2.v;
              if (!(myToken !== _this2._fetchToken)) {
                _context2.n = 5;
                break;
              }
              return _context2.a(2);
            case 5:
              list = (res === null || res === void 0 ? void 0 : (_res$data4 = res.data) === null || _res$data4 === void 0 ? void 0 : _res$data4.list) || (res === null || res === void 0 ? void 0 : (_res$data5 = res.data) === null || _res$data5 === void 0 ? void 0 : _res$data5.post_list) || (res === null || res === void 0 ? void 0 : (_res$data6 = res.data) === null || _res$data6 === void 0 ? void 0 : _res$data6.items) || (res === null || res === void 0 ? void 0 : (_res$data7 = res.data) === null || _res$data7 === void 0 ? void 0 : _res$data7.user_post_list) || (res === null || res === void 0 ? void 0 : res.data) || {};
              items = Array.isArray(list === null || list === void 0 ? void 0 : list.items) ? list.items : Array.isArray(list) ? list : [];
              _this2.items = _this2.items.concat(items);
              _this2.page += 1;
              totalCount = Number((list === null || list === void 0 ? void 0 : list.total_count) || (list === null || list === void 0 ? void 0 : list.totalCount) || 0);
              if (items.length < _this2.size || totalCount > 0 && _this2.items.length >= totalCount) {
                _this2.finished = true;
              }
              _context2.n = 8;
              break;
            case 6:
              _context2.p = 6;
              _t2 = _context2.v;
              if (!(myToken !== _this2._fetchToken)) {
                _context2.n = 7;
                break;
              }
              return _context2.a(2);
            case 7:
              _this2.error = true;
              showToast((_t2 === null || _t2 === void 0 ? void 0 : _t2.message) || '加载作品失败');
            case 8:
              _context2.p = 8;
              if (myToken === _this2._fetchToken) {
                _this2._fetching = false;
                _this2.loading = false;
                // 首屏未填满容器时，van-list 的滚动监听不会触发，
                // 主动 check 一次让其继续加载下一页（finished/error 状态下会自动跳过）。
                _this2.$nextTick(function () {
                  var vlist = _this2.$refs.vlistRef;
                  if (vlist && typeof vlist.check === 'function') vlist.check();
                });
              }
              return _context2.f(8);
            case 9:
              return _context2.a(2);
          }
        }, _callee2, null, [[3, 6, 8, 9]]);
      }))();
    },
    onLoad: function onLoad() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return _this3.fetchList({
                reset: false
              });
            case 1:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    onRefresh: function onRefresh() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              _this4.refreshing = true;
              _context4.p = 1;
              _context4.n = 2;
              return _this4.fetchUser();
            case 2:
              _context4.n = 3;
              return _this4.fetchList({
                reset: true
              });
            case 3:
              _context4.p = 3;
              _this4.refreshing = false;
              return _context4.f(3);
            case 4:
              return _context4.a(2);
          }
        }, _callee4, null, [[1,, 3, 4]]);
      }))();
    },
    onRetry: function onRetry() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _context5.n = 1;
              return _this5.fetchList({
                reset: true
              });
            case 1:
              return _context5.a(2);
          }
        }, _callee5);
      }))();
    },
    onOpenDetail: function onOpenDetail(item) {
      var postId = (item === null || item === void 0 ? void 0 : item.post_id) || (item === null || item === void 0 ? void 0 : item.postId) || '';
      var bridge = this.getBridge();
      if (bridge && typeof bridge.openVideoDetail === 'function' && postId) {
        bridge.openVideoDetail({
          postId: String(postId)
        });
        return;
      }
      this.onOpenUserHomeInApp();
    },
    onFollowClick: function onFollowClick() {
      this.onOpenUserHomeInApp();
    },
    onMessageClick: function onMessageClick() {
      this.onOpenUserHomeInApp();
    }
  },
  mounted: function mounted() {
    this.resolveBeUserId();
    this.fetchUser();
    this.fetchList({
      reset: true
    });
  }
};